export function createPromiseLoadImage(src: string): Promise<string> {
  return new Promise<string>((resolve, reject) => {
    const img = new Image();
    img.addEventListener('load', () => resolve(src));
    img.addEventListener('error', err => reject(err));
    img.src = src;
  });
}



// WEBPACK FOOTER //
// ./src/components/App/imageQueue/utils/createPromiseLoadImage.ts